<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-personal-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-personal-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-personal-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('personal')
    }
  },
  methods: {
    ...mapMutations([
      'selectPersonalStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectPersonalStatus(1);
      this.goToItem('personal');
    },
    chooseMedium: function () {
      this.selectPersonalStatus(2);
      this.goToItem('personal');
    },
    chooseTop: function () {
      this.selectPersonalStatus(3);
      this.goToItem('personal');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-personal-basic {
  background-image: url('../../assets/questions/personal-minimum.jpg');
}
.lt-fyf-answer-personal-medium {
  background-image: url('../../assets/questions/personal-moderate.jpg');
}
.lt-fyf-answer-personal-top {
  background-image: url('../../assets/questions/personal-comfortable.jpg');
}
</style>